import api from "@/lib/axios";
import Cookies from "js-cookie";
import { queryClient } from "@/lib/queryClient";
import useAuth from "@/hooks/stores/useAuth";
import ResetPassword from "@/pages/NotProtectedOnly/ResetPassword";

export const authService = {
  login: async (credentials) => {
    const response = await api.post("/auth/otp/send", credentials);

    return response.data;

  },

  verifyOtp: async (credentials) => {
    const response = await api.post("/auth/otp/verify-or-authenticate", credentials);
    
    const { meta, data } = response.data;
    // Store tokens in store
    const { setTokens } = useAuth.getState();

    setTokens(meta.access_token, meta.refresh_token, data.user.id, data.user.roles[0]?.title, data);

    // Clear cache after successful login
    queryClient.clear();

    return response.data;
  },

  candidateLogin: async (credentials) => {
    const response = await api.post("/candidate/auth/login", credentials);

    const { meta , data } = response.data;
    // Store tokens in store
    const { setTokens } = useAuth.getState();

    setTokens(meta.access_token, meta.refresh_token, data.user.id, data.user.roles[0]?.title, data);


    // Clear cache after successful login
    queryClient.clear();

    return response.data;
  },

  refreshToken: async (refreshToken) => {
    try {
      const response = await api.post("/auth/refresh-token", {
        refreshToken,
      });
      return response.data;
    } catch (error) {
      throw new Error("Token refresh failed: " + error.message);
    }
  },

  forgotPassword: async (email) => {
    try {
      const response = await api.post("/forgot-password", { email });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  ResetPassword: async (payload) => {
    try {
      // const payload = {
      //   email,
      //   password,
      //   password_confirmation,
      //   token,
      // };

      const response = await api.post("/reset-password", payload);
      return response.data;
    } catch (error) {
      // Optionally, log or show more meaningful error
      //console.error("Reset password failed:", error.response?.data || error.message);
      throw error;
    }
  },


  getProfile: async () => {
    try {
      const { userID } = useAuth.getState();
      const response = await api.post(`/users/show`, {
        user_id: userID
      });
      return response.data;
    } catch (error) {
      throw new Error("Failed to fetch profile: " + error.message);
    }
  },

  logout: async () => {
    try {
      const { clearTokens } = useAuth.getState();
      clearTokens();
      queryClient.clear();
    } catch (error) {
      throw new Error("Logout failed: " + error.message);
    }
  },
};
